const BASKET = "basket/";

export const UPDATE_SELECT_SEATS = BASKET + "updateSelectSeats";
export const UPDATE_BASKET_LENGTH = BASKET + "updateBasketLength";
export const UPDATE_CALENDAR_SALE_QNT_STATE = BASKET + "updateCalendarSaleQntState";
export const SET_PROMO_MESSAGE = BASKET + "setPromoMessage";
export const SET_BASKET_ADD_ERROR = BASKET + "setAddError";
export const SET_CURRENT_PROMO_CODE = BASKET + "setCurrentPromoCode";
export const FETCH_BASKET = BASKET + "fetchBasket";
export const ADD_BASKET_ITEM = BASKET + "addBasketItem";
export const ADD_LIMITED_BASKET_ITEM = BASKET + "addLimitedBasketItem";
export const PROLONG_BASKET_PASS = BASKET + "prolongBasketPass";
export const ASSIGN_ASSORT = BASKET + "assignAssort";
export const APPLY_PROMO_CODE = BASKET + "applyPromoCode";
export const RESET_PROMO = BASKET + "resetPromo";
export const CLEAR_BASKET = BASKET + "clearBasket";
export const RESET_BASKET = BASKET + "resetBasket";
